import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AES, enc } from 'crypto-ts';
import { environment } from '../../../environments/environment.prod';


function getDeviceUUID(): string {
  //let uuid = uuidv5('https://digit4ll.com', uuidv5.DNS);
  return 'cd7e9450-e693-53df-bc25-027bc3939889';
}

function decryptDataLocalStorage(objectName: string): any | null {
  try {
    let guid = getDeviceUUID();
    let resp = localStorage.getItem(objectName);
    if (resp != null && resp != 'null') {
      let bytes = AES.decrypt(resp, guid);
      if (bytes != null) {
        let decodeValue = JSON.parse(bytes.toString(enc.Utf8).toString());
        return decodeValue;
      }
    }
    //data receive by shared/iframe website() should be save on localstortage when event is received
    return null;
  } catch (e) {
    console.log("Fichier utilisateur corrompus, merci d'effacer les données de l'application");
    return null;
  }
}


export function jwtInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

  let resp = decryptDataLocalStorage('userSession');
  if (resp != null && !request.url.includes('netcore/pa/')) { //TODO remove require for debug phase, PA API must be use espace-client.obexto.fr/auth for authentification
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${resp.currentUser}`,
          Pragma: 'no-cache',
          Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
          'Cache-Control': 'no-cache',
        },
      });
  }


  return next(request);
}
